import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import commonEs from './es/common.json';

const fallbackLanguage = 'es';
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      es: {
        translation: commonEs, // 'common' is our custom namespace
      },
    },
    fallbackLng: fallbackLanguage,
    returnObjects: true,
    debug: true,
    react: {
      useSuspense: true,
    },
    lng: 'es', // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })
  .then(() => {})
  .catch((err) => {
    console.error(err);
  });

export default i18n;
